/**
 *  서버 공통 응답 코드
 */
export const COMMON_RES_CODE = {
  /**
   *  server exception 이 발생한 경우
   */
  SERVER_ERROR: 0,

  /**
   *  성공
   */
  SUCCESS: 1,

  /**
   *  유효하지 않은 토큰일 경우
   */
  INVALID_TOKEN: 2,

  /**
   *  유효기간 만료된 토큰
   */
  EXPIRATION_TOKEN: 3,

  /**
   *  유효하지 않은 상세 ID 값
   */
  INVALID_DETAIL_ID: 8,
  /**
   *  잘못된 비밀번를 입력했을 경우 ,
   */
  INVALID_PASSWORD: 101,
  /**
   *  활성화 만료된 유저가 로그인을 시도했을 경우,
   */
  INACTIVE_USER: 102,
  /**
   *  활성화 만료된 유저가 api요청을 시도했을 경우,
   */
  INACTIVE_USER_INVALID_REQUEST: 403,
  /**
   *  토큰이 만료된 유저가 api요청을 시도했을 경우,
   */
  EXPIRATION_TOKEN_USER_REQUEST: 401,
  /**
   *  권한이 없는 유저가 api 요청을 시도했을 경우.
   */
  UNAUTHENTICATED_USER_REQUEST: 18,
};
